/**
 * @class FileFormat
 */
export default class FileFormat {
    /**
     * @param {String}  key
     * @param {String}  name
     * @param {String}  contentKey
     * @param {String}  pathKey
     * @param {String}  fileType
     * @param {String}  fileExtension
     * @param {String}  fileName
     * @param {Boolean} mandatory
     * @param {String}  path
     * @param {String}  content
     */
    constructor(key, name, contentKey, pathKey, fileType, fileExtension, fileName, mandatory, path = "", content = "") {
        this._key = key;
        this._name = name;
        this._contentKey = contentKey;
        this._pathKey = pathKey;
        this._fileType = fileType;
        this._fileExtension = fileExtension;
        this._fileName = fileName;
        this._mandatory = mandatory;
        this._path = path;
        this._content = content;

        if (typeof this._key !== "string") {
            throw new Error("Invalid datatype of key");
        }
    }

    /**
     * @return {String}
     */
    get key() {
        return this._key;
    }

    /**
     * @param {String} key
     */
    set key(key) {
        this._key = key;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get contentKey() {
        return this._contentKey;
    }

    /**
     * @param {String} contentKey
     */
    set contentKey(contentKey) {
        this._contentKey = contentKey;
    }

    /**
     * @return {String}
     */
    get pathKey() {
        return this._pathKey;
    }

    /**
     * @param {String} pathKey
     */
    set pathKey(pathKey) {
        this._pathKey = pathKey;
    }

    /**
     * @return {String}
     */
    get fileType() {
        return this._fileType;
    }

    /**
     * @param {String} fileType
     */
    set fileType(fileType) {
        this._fileType = fileType;
    }

    /**
     * @return {String}
     */
    get fileExtension() {
        return this._fileExtension;
    }

    /**
     * @param {String} fileExtension
     */
    set fileExtension(fileExtension) {
        this._fileExtension = fileExtension;
    }

    /**
     * @return {String}
     */
    get fileName() {
        return this._fileName;
    }

    /**
     * @param {String} fileName
     */
    set fileName(fileName) {
        this._fileName = fileName;
    }

    /**
     * @return {Boolean}
     */
    get mandatory() {
        return this._mandatory;
    }

    /**
     * @param {Boolean} mandatory
     */
    set mandatory(mandatory) {
        this._mandatory = mandatory;
    }

    /**
     * @return {String}
     */
    get path() {
        return this._path;
    }

    /**
     * @param {String} path
     */
    set path(path) {
        this._path = path;
    }

    /**
     * @return {String}
     */
    get content() {
        return this._content;
    }

    /**
     * @param {String} content
     */
    set content(content) {
        this._content = content;
    }

    /**
     * @ return {Object}
     */
    clone() {
        return new FileFormat(
            this._key,
            this._name,
            this._contentKey,
            this._pathKey,
            this._fileType,
            this._fileExtension,
            this._fileName,
            this._mandatory,
            this._path,
            this._content
        );
    }

    /**
     * Clones FileFormat object and updates path property.
     * @param {String}  path
     * @return {Object}
     */
    updatePath = (path) => {
        let file = this.clone();
        file.path = path;

        return file;
    };

    /**
     * Clones FileFormat object and updates content property.
     * @param {String}  content
     * @return {Object}
     */
    updateContent = (content) => {
        let file = this.clone();
        file.content = content;

        return file;
    };

    /**
     * @return {String}
     */
    toString() {
        return "FileFormat (" + this._key + ")";
    }
}
